import { useAppState } from "@hooks/useAppState"
import { useRef } from "react"
import { PillarRenderer } from "./PillarRenderer"

/**
 * Renders the pillar background, always on every page.
 */
export function BackgroundRenderer() {
  const container = useRef<HTMLDivElement>(null!)
  const state = useAppState()
  const opacity = 1 - state.background.darken

  return (
    <div ref={container} className="fixed z-0 inset-0 pointer-events-none">
      <PillarRenderer scene={state.background.scene} opacity={opacity} />
    </div>
  )
}
